// interweave needs a DOM to parse HTML. On the server it comes from
// interweave-ssr (parse5, ~320 KB of source); the browser has a real DOM.
// Next inlines `typeof window` at build time, so the require below is
// dropped from client bundles.
export const polyfillInterweaveOnServer = () => {
  if (typeof window === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    require('interweave-ssr').polyfill();
  }
};
